<template>
  <div class="pay-coupon-detail-div">
    <div class="take-foot-div">
      <van-cell title="选择优惠券" @click="selectCoupon">
        <div slot="default">
          <!-- <div v-if="sCouponObj.length > 0">
            <div class="buy_detail_name coupon-box" v-for="item in sCouponObj" :key="item.couponId">
              <span class="coupon-name"></span>
              <span class="coupon-num">-￥{{item.discountAmount}}</span>
            </div>
          </div> -->
          <div class="buy_detail_name coupon-box" v-if="sCouponObj.length > 0">
            <span class="coupon-name"></span>
            <span class="coupon-num"
              >-￥{{ parseFloat(sActual).toFixed(2) }}</span
            >
          </div>
          <div v-else>选择优惠券</div>
        </div>
      </van-cell>
    </div>
    <van-action-sheet v-model="show" title="选择优惠券">
      <div class="content">
        <div class="">
          <van-field
            v-model="couponCode"
            center
            clearable
            label="兑换码"
            label-width="60"
            input-align="left"
            placeholder="请输入兑换码"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                color="rgb(0, 110, 63)"
                @click="addCouponBtn()"
                >兑换</van-button
              >
            </template>
          </van-field>
        </div>
        <div class="coupon-list">
          <div class="list-box">
            <div
              class="item"
              @click="selectItemCoupon(item)"
              v-for="(item, index) in couponData"
              :key="index"
            >
              <div class="item-left">
                <img src="../../assets/xingbake_1.png" alt="" />
              </div>
              <div class="item-content">
                <div class="item-name">
                  {{
                    parseFloat(item.price) == 38
                      ? "中杯通兑券"
                      : item.priceHint + "元在线点单代金券"
                  }}
                </div>
                <div style="color: #414141">
                  优惠券码：{{ item.ticketCode }}
                </div>
                <div style="color: #666">本券不找零不兑现，不可拆分使用</div>
                <div style="color: #999999">
                  有效期至：{{ item.expireDate }}
                </div>
              </div>
              <div class="item-right">
                <img
                  src="../../assets/select_1.png"
                  v-if="findUserCardId(item.userCardId)"
                  mode=""
                />
                <img src="../../assets/select_0.png" v-else mode="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { getCouponList, addCoupon } from "@/request/api";
import {
  Col,
  Row,
  Field,
  Cell,
  CellGroup,
  ActionSheet,
  Button,
  Notify,
  Empty,
} from "vant";
export default {
  name: "PayCoupon",
  props: {
    isNotSelect: false, 
  },
  computed: mapGetters([
    "sUserInfo",
    "sCouponObj",
    "sActual",
    "couponId",
    "getGoodsList",
    "getGoodsNum"
  ]),
  components: {
    [Col.name]: Col,
    [Notify.name]: Notify,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Empty.name]: Empty,
    [Field.name]: Field,
  },
  data() {
    return {
      phone: "",
      code: "",
      couponData: [
        // {userCardId:37,price:30,ticketCode:'123132',expireDate:'2023-01-01',priceHint:30,statusHint:30,discountAmount:30,couponId:37},
        // {userCardId:38,price:28,ticketCode:'12312',expireDate:'2023-01-03',priceHint:28,statusHint:28,discountAmount:28,couponId:38},
      ],
      couponSelectId: null,
      show: false,
      couponCode: "",
    };
  },
  watch: {
    isNotSelect: {
      handler(nval) {
        if (nval) {
          // this.getPayCoupon();
        }
      },
    },
  },
  created() {
    this.clearCouponObj();
    this.clearSortCoup();
    // console.log(this.getGoodsList);
  },
  mounted() {
    // this.$nextTick(()=>{
    this.getPayCoupon();
    // })
  },
  methods: {
    ...mapMutations([
      "setCouponObj",
      "delCouponObj",
      "clearCouponObj",
      "clearSortCoup",
    ]),
    selectItemCoupon(item) {
      let bool = this.findUserCardId(item.userCardId);
      if (bool) {
        this.delCouponObj(item);
      } else {
        // 根据商品杯数来选择卡券数量
        if (this.sCouponObj.length < this.getGoodsNum) {
          this.setCouponObj(item);
        }
      }
    },
    addCouponBtn() {
      addCoupon(this.couponCode)
        .then((resolve) => {
          Notify({ type: "success", message: "添加成功" });
          this.getPayCoupon();
        })
        .catch((error) => {});
    },
    getPayCoupon() {
      getCouponList("3").then((res) => {
        res.retData.forEach((item) => {
          item.userCardId = item.couponId;
          item.discountAmount = item.priceHint;
          item.cardName = "优惠券";
          item.expireTime = item.expireDate;
          if (
            this.couponId.length > 0 &&
            this.couponId.find((id) => id == item.couponId)
          ) {
            this.setCouponObj(item);
          }
        });
        this.couponData = res.retData;
        console.log(this.couponData, "卡券列表", "paycoupon");
      });
    },
    selectCoupon() {
      this.couponCode = "";
      // 再支付订单不能选择卡券
      if (this.isNotSelect) {
        return;
      }
      this.show = true;
    },
    findUserCardId(cardId) {
      let finded = this.sCouponObj.find((item) => item.userCardId == cardId);
      return finded ? true : false;
    },
    // getAllCouponPrice() {
    //   let all = 0;
    //   if (this.sCouponObj.length > 0) {
    //     for (let i = 0; i < this.sCouponObj.length; i++) {
    //       const element = this.sCouponObj[i];
    //       all += element.discountAmount;
    //     }
    //   }
    //   return all;
    // },
  },
};
</script>
	
<style scoped >
.pay-coupon-detail-div {
  background-color: #ffffff;
  margin-top: 10px;
  padding: 10px 0;
}
.coupon-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 5px;
}
.coupon-name {
  color: #999;
}

.coupon-num {
  color: #fd3e3f;
  font-size: 16px;
}

.list-box {
  padding: 15px;
  height: 400px;
  overflow: auto;
  background: #f2f2f2;
}
.list-box .item {
  display: flex;
  height: 100px;
  background: #fff;
  background-size: 100% 100%;
  margin-bottom: 15px;
  padding-left: 10px;
  justify-content: space-between;
  align-items: center;
}
.list-box .item .item-left {
  /* width: 333px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* padding-left: 40rpx; */
}
.item-left img {
  width: 67px;
  height: 67px;
}
.list-box .item .item-goods-name {
  font-size: 13px;
  color: #666666;
  padding-left: 5px;
}
.list-box .item .item-goods-detail {
  display: flex;
  align-items: center;
}
.list-box .item .item-goods-detail .item-goods-name {
  color: #333;
  font-size: 21px;
}
.list-box .item .item-goods-price {
  font-size: 21px;
  display: flex;
  align-items: center;
  color: #f46921;
}
.list-box .item .item-goods-price .unit {
  font-size: 10px;
}
.list-box .item .item-time {
  color: #999;
  font-size: 10px;
}
.list-box .item .item-content {
  font-size: 10px;
}
.item-content .item-name {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}
.list-box .item .item-right {
  width: 80px;
  /* padding-right: 30px; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #fe483a;
}
/* .coupon-list{
		height: 400px;
		overflow-y: auto;
	} */
.list-box .item .item-right img {
  width: 20px;
  height: 20px;
}
/* .list-box .item .item-content {
	  display: flex;
	}
	.list-box .item .item-content .item-goods-logo {
	  width: 45px;
	  height: 45px;
	} */
/* .list-box .item.have-been-used-item {
	  background: url(../../assets/have-been-used.png) no-repeat;
	  background-size: 100% 100%;
	}
	.list-box .item.have-been-used-item .use-btn {
	  color: #666;
	}
	.list-box .item.have-been-used-item .item-detail .title {
	  color: #666;
	} */
</style>
